//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Subscribes',

  props: {
    user: {
      type: Object,
      default: () => {}
    },
    hideIntro: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      site: null,
    }
  },

  async fetch() {
    this.site = await this.$axios.$get(`${process.env.BASE_URL_V2}/public/footer/site_settings/`, { params: { fields: 'telegram_url,vk_url'  } });
  },

  computed: {
    hasSocials() {
      return this.user?.profile?.telegram_url || this.user?.profile?.vk_url || this.user?.profile?.whatsapp_url || this.user?.profile?.phone || this.profileUrls.length
    },
    profileUrls() {
      const urls = this.user?.profile?.urls

      if (Array.isArray(urls)) {
        return urls
          .map((item) => {
            if (typeof item === 'string') return { url: item }
            if (item && typeof item === 'object' && item.url) return item
            return null
          })
          .filter(Boolean)
      }

      return []
    }
  },
}
